<script setup lang="ts">
/**
 * A marca, e é a mesma da V2 — traço por traço.
 *
 * ── POR QUE UMA E NÃO DUAS ────────────────────────────────────────────────
 *
 * A V2 guarda dois arquivos, `…-light` e `…-dark`, idênticos exceto pelo `fill`:
 * um `#1a1045`, o outro `#ffffff`. Dois arquivos para uma diferença de cor
 * significa que qualquer ajuste no desenho tem de ser feito duas vezes, e que o
 * logo não sabe em que tema está — quem sabe é o `v-if` de quem o desenha.
 *
 * Aqui o traço é o mesmo e a cor é `currentColor`: o logo herda a cor do texto do
 * cabeçalho, então ele já está certo no claro, no escuro e dentro de um botão
 * colorido, sem uma segunda cópia e sem ninguém perguntar qual tema está ativo.
 *
 * ── POR QUE INLINE E NÃO UM `<img>` ───────────────────────────────────────
 *
 * Porque um `<img src="…svg">` é uma imagem opaca para o CSS: `currentColor`
 * dentro dela resolve contra o documento do próprio SVG, que não tem tema. Ou se
 * inlina, ou se voltam os dois arquivos.
 *
 * O nome fica no `aria-label` de quem envolve isto (o link para a home) — aqui é
 * decoração, e um leitor de tela que anuncia "Benvox, Benvox" é pior do que um
 * que anuncia uma vez.
 *
 * Sem `props`: a altura vem da classe que quem desenha passa, e o Vue já a
 * entrega no `<svg>` sozinho (atributo de passagem). Uma prop `class` aqui seria
 * a mesma classe chegando duas vezes.
 */
</script>

<template>
	<svg
		viewBox="0 0 986 234"
		fill="currentColor"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		focusable="false"
	>
		<g transform="translate(60.0,184.0) scale(0.2,-0.2)">
			<path
				d="M434 0C572 0 649 70 649 185C649 273 593 335 479 348V355C581 367 625 426 625 505C625 611 548 670 420 670H45V0ZM152 573H408C483 573 518 544 518 481C518 418 480 389 405 389H152ZM152 300H422C501 300 541 270 541 200C541 127 502 97 422 97H152Z"
			/>
		</g>
		<g transform="translate(201.8,184.0) scale(0.2,-0.2)">
			<path d="M586 0V97H158V289H571V385H158V573H586V670H50V0Z" />
		</g>
		<g transform="translate(333.8,184.0) scale(0.2,-0.2)">
			<path d="M158 0V393L154 509H162L246 391L548 0H664V670H556V274L561 153H553L466 278L166 670H50V0Z" />
		</g>
		<g transform="translate(478.6,184.0) scale(0.2,-0.2)">
			<path d="M434 0 720 670H593L363 109H355L123 670H-5L281 0Z" />
		</g>
		<g transform="translate(781.8,184.0) scale(0.2,-0.2)">
			<path d="M140 0 354 269H362L579 0H719L449 332V340L719 670H579L366 406H358L140 670H0L270 341V333L0 0Z" />
		</g>
		<!-- O "O" do nome: o anel e o ponto, que é a marca isolada. -->
		<path
			d="M697.8 45 A72 72 0 1 1 697.7 45 Z M697.8 67.1 A49.9 49.9 0 1 0 697.9 67.1 Z"
			fill-rule="evenodd"
		/>
		<circle cx="697.8" cy="117.0" r="16.1" />
	</svg>
</template>
